var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { hasValue, toJSON } from "@utils";
import { DEFAULT_BREAKPOINTS } from '@core/dashboard/dashboardUtils';
const UXPAPP = 'UXP';
// Dashboards
export function getDashboardDetails(uxpContext, dashboardId, subDashboardId) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        if (!uxpContext || !hasValue(dashboardId))
            return null;
        const { data, error } = yield uxpContext.executeServiceSafe(UXPAPP, 'Portal:PortalByID', { id: dashboardId }, { json: true, executeImmidiately: true });
        console.log(data, '________portal_details');
        if (!(data === null || data === void 0 ? void 0 : data[0]) || !!error) {
            console.error('Unable to get dashboard details. Response: ', data, ' Error:', error);
            return null;
        }
        const _c = data[0], { Key, SidebarItems, Roles } = _c, rest = __rest(_c, ["Key", "SidebarItems", "Roles"]);
        const dashboardConfig = {
            details: Object.assign(Object.assign({}, rest), { Key: Key, ParsedSidebarItems: toJSON(SidebarItems, []), ParsedRoles: (Roles || '').split(',').filter(Boolean) }),
            widgetConfiguration: {
                widgets: [],
                layouts: {}
            },
        };
        if (hasValue(subDashboardId) && hasValue(Key)) {
            const { data: userPrefs, error: userPrefsError } = yield uxpContext.executeServiceSafe(UXPAPP, 'GetUserPrefs', { portal: Key, dashboard: subDashboardId }, { json: true, executeImmidiately: true });
            if (userPrefsError) {
                console.error('Unable to get user prefs. Error: ', userPrefsError);
            }
            if (!!((_a = userPrefs === null || userPrefs === void 0 ? void 0 : userPrefs[0]) === null || _a === void 0 ? void 0 : _a.Data)) {
                const widgetConfig = toJSON(((_b = userPrefs === null || userPrefs === void 0 ? void 0 : userPrefs[0]) === null || _b === void 0 ? void 0 : _b.Data) || '', { widgets: [], layouts: {} });
                dashboardConfig.widgetConfiguration = widgetConfig;
            }
        }
        return dashboardConfig || null;
    });
}
export function saveUserPrefs(uxpContext, configurations, portalKey, dashboardKey) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!uxpContext)
            return null;
        const { error } = yield uxpContext.executeServiceSafe(UXPAPP, 'SaveUserPrefs', {
            'data': JSON.stringify(configurations),
            'portal': portalKey,
            'dashboard': dashboardKey
        }, { json: true, executeImmidiately: true });
        if (!!error) {
            console.error('Unable to save user prefs. Error: ', error);
            return false;
        }
        return true;
    });
}
export function saveDefaultUserPrefs(uxpContext, configurations, portalKey, dashboardKey) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!uxpContext)
            return null;
        const { error } = yield uxpContext.executeServiceSafe(UXPAPP, 'SaveDefaultUserPrefs', {
            'data': JSON.stringify(configurations),
            'portal': portalKey,
            'dashboard': dashboardKey
        }, { json: true, executeImmidiately: true });
        if (!!error) {
            console.error('Unable to save default user prefs. Error: ', error);
            return false;
        }
        return true;
    });
}
// Embedded dashboards
export function getEmbeddedDashboardConfigurations(uxpContext, id) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!uxpContext)
            return null;
        const { data, error } = yield uxpContext.executeServiceSafe('UXP', 'EmbeddedDashboard:DetailsByID', { id: id }, { json: true });
        if (error) {
            console.warn('Unable to find the details for embedded dashboard, id: ' + id);
            return null;
        }
        if (!!(data === null || data === void 0 ? void 0 : data[0])) {
            const rawData = data[0];
            return Object.assign(Object.assign({}, rawData), { WidgetConfigurations: toJSON(rawData.WidgetConfigurations, { widgets: [], layouts: {} }) });
        }
    });
}
export function saveEmbeddedDashboardConfiguration(uxpContext, id, widgetConfig) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!uxpContext)
            return null;
        const params = {
            ID: id,
            WidgetConfigurations: JSON.stringify(widgetConfig)
        };
        const { error } = yield uxpContext.executeServiceSafe('UXP', 'EmbeddedDashboard:Save', params, { json: true });
        if (!!error) {
            console.error('Unable to save configurations. Error: ', error);
            return false;
        }
        return true;
    });
}
export function exportEmbeddedDashboard(uxpContext, id, widgetsOnly) {
    if (!uxpContext)
        return null;
    const downloadLink = `/Services/UXP/ExportEmbeddedDashboard?__sc__=${uxpContext.apiKey}&id=${id}&widgetConfigsOnly=${widgetsOnly}`;
    window.open(downloadLink, '_blank');
}
export function deleteEmbededDashboardConfig(uxpContext, id) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!uxpContext)
            return null;
        const { error } = yield uxpContext.executeServiceSafe('UXP', 'EmbeddedDashboard:DeleteByID', { id: id });
        if (error) {
            console.warn('Unable to delete embedded dashboard, id: ' + id, error);
            return false;
        }
        return true;
    });
}
// Global dashboard settings
export function getGlobalDashboardSettings(uxpContext) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const { data, error } = yield uxpContext.executeServiceSafe(UXPAPP, 'UXPGlobalDashboardSetting:GetBySettingKey', { settingKey: 'dashboard' }, { json: true, executeImmidiately: true });
        if (error || !((_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.Value))
            return null;
        try {
            return JSON.parse(data[0].Value);
        }
        catch (_b) {
            return null;
        }
    });
}
export function saveGlobalDashboardSettings(uxpContext, settings) {
    return __awaiter(this, void 0, void 0, function* () {
        const { error } = yield uxpContext.executeServiceSafe(UXPAPP, 'UXPGlobalDashboardSetting:SaveBySettingKey', { settingKey: 'dashboard', value: JSON.stringify(settings) }, { json: true, executeImmidiately: true });
        if (error) {
            console.error('Unable to save global dashboard settings:', error);
            return false;
        }
        return true;
    });
}
export function savePortalConfiguration(uxpContext, portalKey, settings) {
    return __awaiter(this, void 0, void 0, function* () {
        const { error } = yield uxpContext.executeServiceSafe(UXPAPP, 'Portal:SaveConfiguration', { key: portalKey, configuration: JSON.stringify(settings) }, { json: true, executeImmidiately: true });
        if (error) {
            console.error('Unable to save portal configuration:', error);
            return false;
        }
        return true;
    });
}
const DEFAULT_GRID_SETTINGS = { showGridlines: false, showEmptyPlaceholder: true, margin: 10, containerPadding: 10, allowFreePositioning: false };
export function mergeSettings(global, perDashboard, legacyGridSettings) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const defaults = Object.assign(Object.assign({}, DEFAULT_GRID_SETTINGS), ((global === null || global === void 0 ? void 0 : global.defaults) || {}));
    const globalBreakpoints = global === null || global === void 0 ? void 0 : global.breakpoints;
    const activeBreakpoints = globalBreakpoints
        ? globalBreakpoints.filter(b => b.enabled).map(b => {
            var _a, _b, _c;
            return ({
                key: b.key,
                width: b.width,
                columns: (_c = (_a = b.columns) !== null && _a !== void 0 ? _a : (_b = DEFAULT_BREAKPOINTS[b.key]) === null || _b === void 0 ? void 0 : _b.columns) !== null && _c !== void 0 ? _c : 12
            });
        })
        : Object.entries(DEFAULT_BREAKPOINTS).map(([key, v]) => ({ key, width: v.width, columns: v.columns }));
    return {
        activeBreakpoints,
        showGridlines: (legacyGridSettings === null || legacyGridSettings === void 0 ? void 0 : legacyGridSettings.showGridlines) === true ? true : defaults.showGridlines,
        showEmptyPlaceholder: (legacyGridSettings === null || legacyGridSettings === void 0 ? void 0 : legacyGridSettings.showEmptyPlaceholder) === false ? false : defaults.showEmptyPlaceholder,
        margin: (_b = (_a = perDashboard === null || perDashboard === void 0 ? void 0 : perDashboard.margin) !== null && _a !== void 0 ? _a : legacyGridSettings === null || legacyGridSettings === void 0 ? void 0 : legacyGridSettings.margin) !== null && _b !== void 0 ? _b : defaults.margin,
        containerPadding: (_d = (_c = perDashboard === null || perDashboard === void 0 ? void 0 : perDashboard.containerPadding) !== null && _c !== void 0 ? _c : legacyGridSettings === null || legacyGridSettings === void 0 ? void 0 : legacyGridSettings.containerPadding) !== null && _d !== void 0 ? _d : defaults.containerPadding,
        allowFreePositioning: (legacyGridSettings === null || legacyGridSettings === void 0 ? void 0 : legacyGridSettings.allowFreePositioning) === true ? true : defaults.allowFreePositioning,
        overlayMode: (_e = perDashboard === null || perDashboard === void 0 ? void 0 : perDashboard.overlayMode) !== null && _e !== void 0 ? _e : false,
        enableBackgroundConfig: (_f = perDashboard === null || perDashboard === void 0 ? void 0 : perDashboard.enableBackgroundConfig) !== null && _f !== void 0 ? _f : false,
        enableUserGroupLayouts: (_g = perDashboard === null || perDashboard === void 0 ? void 0 : perDashboard.enableUserGroupLayouts) !== null && _g !== void 0 ? _g : false,
        enableResponsiveLayouts: (_h = perDashboard === null || perDashboard === void 0 ? void 0 : perDashboard.enableResponsiveLayouts) !== null && _h !== void 0 ? _h : true,
    };
}
// Other
export function getAllUserGroups(uxpContext) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!uxpContext)
            return null;
        const { data, error } = yield uxpContext.executeServiceSafe('System', 'UserGroup:All', { max: 1000 }, { json: true });
        if (!!error) {
            console.error('Unable to get user groups. Error: ', error);
            return [];
        }
        return data || [];
    });
}
/**
 * Save a view override configuration
 */
export function saveViewOverride(uxpContext, viewId, pageId, configuredProps) {
    return __awaiter(this, void 0, void 0, function* () {
        // Normalize to lowercase
        const normalizedViewId = viewId.toLowerCase();
        const normalizedPageId = pageId.toLowerCase();
        return uxpContext.executeServiceSafe('System', 'AccountViewOverride:Save', {
            viewId: normalizedViewId,
            pageId: normalizedPageId,
            configuredProps: configuredProps != null ? JSON.stringify(configuredProps) : ''
        });
    });
}
/**
 * Delete a view override configuration (reset to default)
 */
export function deleteViewOverride(uxpContext, viewId) {
    return __awaiter(this, void 0, void 0, function* () {
        const normalizedViewId = viewId.toLowerCase();
        return uxpContext.executeServiceSafe('System', 'AccountViewOverride:DeleteByViewId', { viewId: normalizedViewId });
    });
}
export function getViewOverrides(uxpContext) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const { data, error } = yield uxpContext.executeServiceSafe('System', 'GetViewOverrides', {}, { json: true });
        if (!!error) {
            console.error('Unable to get view overrides. Error: ', error);
            return {};
        }
        return toJSON((_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.viewoverrides, {});
    });
}
// Object Tab Services
export function saveObjectTab(uxpContext, tab) {
    return __awaiter(this, void 0, void 0, function* () {
        return uxpContext.executeServiceSafe('System', 'AccountObjectTab:Save', Object.assign(Object.assign({}, tab), { objectType: tab.objectType.toLowerCase(), contributionId: tab.contributionId.toLowerCase(), components: JSON.stringify(tab.components) }));
    });
}
export function deleteObjectTab(uxpContext, tabId) {
    return __awaiter(this, void 0, void 0, function* () {
        return uxpContext.executeServiceSafe('System', 'AccountObjectTab:Delete', { tabId });
    });
}
export function reorderObjectTabs(uxpContext, items) {
    return __awaiter(this, void 0, void 0, function* () {
        return uxpContext.executeServiceSafe('System', 'AccountObjectTab:Reorder', {
            items: JSON.stringify(items)
        });
    });
}
function parseObjectTabsResponse(raw) {
    return Object.fromEntries(Object.entries(raw).map(([key, tabs]) => [
        key,
        (tabs || []).map(tab => (Object.assign(Object.assign({}, tab), { components: Array.isArray(tab.components)
                ? tab.components
                : (toJSON(tab.components, []) || []) })))
    ]));
}
export function getObjectTabs(uxpContext) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const { data, error } = yield uxpContext.executeServiceSafe('System', 'GetObjectTabs', {}, { json: true });
        if (!!error) {
            console.error('Unable to get object tabs. Error: ', error);
            return {};
        }
        return parseObjectTabsResponse(toJSON((_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.objecttabs, {}));
    });
}
// Localization Services
/**
 * Get custom localization messages by code from System service
 */
export function getCustomMessagesByCode(uxpContext, code) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield uxpContext.executeServiceSafe('UXP', 'GetCustomLocalisationMessagesByCode', { code }, { json: true, executeImmidiately: true });
        if (error) {
            console.error('Unable to get custom messages by code. Error:', error);
            return [];
        }
        return data || [];
    });
}
/**
 * Create a new custom localization message
 */
export function createCustomMessage(uxpContext, params) {
    return __awaiter(this, void 0, void 0, function* () {
        return uxpContext.executeServiceSafe('System', 'CustomLocalizedMessage:Create', params, { json: true, executeImmidiately: true });
    });
}
/**
 * Update an existing custom localization message
 */
export function updateCustomMessage(uxpContext, params) {
    return __awaiter(this, void 0, void 0, function* () {
        return uxpContext.executeServiceSafe('System', 'CustomLocalizedMessage:Update', params, { json: true, executeImmidiately: true });
    });
}
/**
 * Translate text using Google Translate V2
 */
export function translateText(uxpContext, params) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const { data, error } = yield uxpContext.executeServiceSafe('UXP', 'GoogleTranslateV2', params, { json: true, executeImmidiately: true });
        if (error || !((_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.translated)) {
            console.error('Unable to translate text. Error:', error);
            return null;
        }
        return data[0];
    });
}
/**
 * Save localization messages (handles both create and update).
 * This matches the onSave prop signature in LocalisationForm.
 * @export
 */
export function saveLocalizations(uxpContext, code, messages) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            // Filter only modified messages
            const modifiedMessages = messages.filter(m => m.hasModified);
            if (modifiedMessages.length === 0) {
                return { success: true };
            }
            // Process all messages in parallel
            const results = yield Promise.allSettled(modifiedMessages.map((msg) => __awaiter(this, void 0, void 0, function* () {
                if (hasValue(msg.key)) {
                    // Update existing message
                    return yield updateCustomMessage(uxpContext, {
                        Key: msg.key,
                        Message: msg.message
                    });
                }
                else {
                    // Create new message
                    return yield createCustomMessage(uxpContext, {
                        MessageCode: code,
                        LanguageCode: msg.languageCode,
                        LanguageName: msg.languageName,
                        Message: msg.message
                    });
                }
            })));
            // Check if any failed
            const failures = results.filter(r => r.status === 'rejected' || (r.status === 'fulfilled' && r.value.error));
            if (failures.length > 0) {
                console.error('Some localization messages failed to save:', failures);
                return { success: false, error: 'Some messages failed to save' };
            }
            return { success: true };
        }
        catch (error) {
            console.error('Error saving localizations:', error);
            return { success: false, error: 'Failed to save localization messages' };
        }
    });
}
